import React, { useState, useMemo } from "react";
import FilterComponent from "../Layout/FilterComponent";
import SearchExportComponent from "../Layout/SearchExportComponent";
import TableLayout from "../Layout/TableLayout";
import Pagination from "../Layout/Pagination";
import DetailBox from "./DetailBox";
import SearchExportFilterComponent from "../Layout/SearchExportFilterComponent";
import { COMPANIES } from "../../constants/fetchData";
import { getExportData, getDistributorNames } from "../../Common/functions";
import { getPurchaseOrderReportsForExport } from "../../services/purchaseOrderService";

const PurchaseOrderOverview = ({
  data,
  loading,
  currentPage,
  totalPages,
  totalCount,
  setCurrentPage,
  userRole,
  setSearchTerm,
  setFilters,
  itemsPerPage,
  setItemsPerPage,
  filters,
}) => {
  const [openDetailBox, setOpenDetailBox] = useState(false);
  const [selectedObject, setSelectedObject] = useState([]);
  const [currentSearchTerm, setCurrentSearchTerm] = useState(""); // Local search term state

  const [visibleHeaders, setVisibleHeaders] = useState([
    "dates",
    "created_date",
    "salesorder_number",
    "distributor_name",
    "amount",
    "po_date",
    "order_status",
    "action",
  ]);
  const tableHeaders = [
    { label: "PO Date", value: "dates" },
    { label: "Sales Order No", value: "salesorder_number" },
    { label: "Distributor", value: "distributor_name" },
    { label: "Amount", value: "amount" },
    { label: "Created date", value: "created_date" },
    { label: "Product Group", value: "product_group" },
    { label: "Category", value: "category" },
    { label: "Discount", value: "discount" },
    { label: "Quantity", value: "total_quantity" },
    { label: "Place of Supply", value: "place_of_supply" },
    { label: "Delivery Method", value: "delivery_method" },
    { label: "Discount Type", value: "discount_type" },
    { label: "Order Status", value: "order_status" },
    { label: "Action", value: "action" },
  ];
  const filterFields = [
    {
      type: "dropdown",
      label: "Distributor name",
      id: "distributorName",
      options: COMPANIES,
      // [
      //   { value: "1", label: "Distributor 1" },
      //   { value: "2", label: "Distributor 2" },
      // ],
    },
    { type: "date", label: "From Date", id: "fromDate" },
    { type: "date", label: "To Date", id: "toDate" },
  ];
  const handleApplyFilters = (appliedFilters) => {
    console.log("appliedFilters", appliedFilters);
    setFilters(appliedFilters);
  };
  const handleResetFilters = () => setFilters({});
  const handleSearch = (term) => {
    setCurrentSearchTerm(term);
    setSearchTerm(term);
  };
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => setCurrentPage(page);
  
  const handleExport = async () => {
    try {
      // Show loading state or disable export button
      console.log("Starting purchase order export process...");
      
      let distributorName;
      if (userRole === "super_admin") {
        distributorName = filters.distributorName;
      } else if (userRole === "manager") {
        distributorName =
          !filters.distributorName || filters.distributorName.trim() === ""
            ? getDistributorNames()
            : filters.distributorName;
      } else {
        distributorName = getDistributorNames();
      }

      const exportFilters = {
        category: "Sales Order",
        start_date: filters.fromDate,
        end_date: filters.toDate,
        search_term: currentSearchTerm,
        distributor_name: distributorName,
      };

      const result = await getPurchaseOrderReportsForExport(exportFilters);
      
      if (result?.data?.items) {
        console.log(`Export completed: ${result.data.items.length} records fetched`);
        return result.data.items; // Return the data for the export dialog
      } else {
        console.error("No data received for export");
        return [];
      }
    } catch (error) {
      console.error("Error during export:", error);
      return [];
    }
  };

  const handleViewAction = (item) => {
    console.log("view");
    console.log("item", item);
    setSelectedObject(item);
    setOpenDetailBox(true);
  };

  // Function to get export data for any dataset
  const getComputedExportData = (dataToExport) => {
    return getExportData(dataToExport, tableHeaders, visibleHeaders);
  };

  const exportData = getExportData(data, tableHeaders, visibleHeaders);
  
  return (
    <div className="px-0 sm:px-4">
      {userRole === "super_admin" || userRole === "manager" ? (
        <div className="mt-6">
          <div className="hidden sm:block">
            <FilterComponent
              fields={filterFields}
              onApply={handleApplyFilters}
              onReset={handleResetFilters}
            />
          </div>
          <SearchExportComponent
            exportFileName="PurchaseOrderReport"
            onSearch={handleSearch}
            onExport={handleExport}
            // searchPlaceholder="Search"
            tablefields={tableHeaders}
            selectedHeaders={visibleHeaders}
            onHeadersChange={setVisibleHeaders}
            fields={filterFields}
            onApply={handleApplyFilters}
            onReset={handleResetFilters}
            exportData={exportData}
            getComputedExportData={getComputedExportData}
          />
        </div>
      ) : (
        <div className="mt-10">
          <SearchExportFilterComponent
            exportFileName="PurchaseOrderReport"
            onSearch={handleSearch}
            onExport={handleExport}
            // searchPlaceholder="Search"
            tablefields={tableHeaders}
            selectedHeaders={visibleHeaders}
            onHeadersChange={setVisibleHeaders}
            fields={filterFields}
            onApply={handleApplyFilters}
            onReset={handleResetFilters}
            GridIconVisibility={userRole !== "distributor_admin"}
            exportData={exportData}
            getComputedExportData={getComputedExportData}
            // ExportOptionVisisbility={userRole !== "manager"}
          />
        </div>
      )}
      <TableLayout
        data={data}
        loading={loading}
        headers={tableHeaders.filter((header) =>
          visibleHeaders.includes(header.value)
        )}
        handleAction={handleViewAction}
      />

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        itemsPerPage={itemsPerPage}
        onItemsPerPageChange={handleItemsPerPageChange}
      />

      {openDetailBox && (
        <DetailBox
          closeModal={() => setOpenDetailBox(false)}
          selectedObject={selectedObject}
        />
      )}
    </div>
  );
};

export default PurchaseOrderOverview;
